import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import ShareIcon from "./ShareIcon.svg"; // Update with your actual icon path
import ShareIcon from "../assets/images/shareicon.png";
import { useChatContext } from "../context/ChatContext";
import { SchoolSignupContext } from "../context/SchoolSignupContext";
import { useContext } from 'react';
import { useParams } from "react-router-dom";
import { decodeToken } from "../utils/commonFunctions";

// import { SchoolSignupContext } from './path/to/SchoolSignupContext';


export default function SharePopupButton() {
const { titleId, checkType ,shareSize} = useChatContext();
  const { signupData } = useContext(SchoolSignupContext);
const { id, types, historySize, schoolCodes } = useParams();

  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const popupRef = useRef(null);

  const userToken = decodeToken();
  const masterTypeId = signupData?.schoolType != null && signupData?.schoolType !== ""
    ? signupData.schoolType
    : (userToken?.masterTypeid ?? "");

  const prefixUrl = window.location.origin;
  const basePath = id && historySize && schoolCodes != null
    ? `${prefixUrl}/afterchatbot/${historySize}/${id}/${types || ""}/${schoolCodes}`
    : `${prefixUrl}/afterchatbot/${shareSize}/${titleId}/${signupData?.schoolType === 1 ? "false" : checkType}/${signupData?.schoolCode || ""}`;
  const shareLink = `${basePath}${masterTypeId !== "" && masterTypeId != null ? `?masterTypeId=${masterTypeId}` : ""}`;
// console.log(shareLink,"shareLink");
  // Close popup on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
        setCopied(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    alert("Link copied! Please share this link only with users from the same school type.");
  };

  return (
    <>
      <style>{`
        .header-share-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          padding: 0;
          margin: 0;
          background: #fff;
          border-radius: 16px;
          border: 1px solid #000;
          cursor: pointer;
          box-sizing: border-box;
          line-height: 1;
          white-space: nowrap;
        }
        .header-share-btn:hover {
          background: #f3f4f6;
        }
        .share-popup-root {
          position: relative;
          display: block;
          width: 100%;
          height: 100%;
        }
        .share-popup {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 300px;
          max-width: min(300px, calc(100vw - 24px));
          background: white;
          border: 1px solid #ddd;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          padding: 12px;
          z-index: 1101;
          font-family: sans-serif;
        }
        .share-popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }
        .share-popup-title {
          font-weight: bold;
          font-size: 15px;
        }
        .share-popup-close-btn {
          background: none;
          border: none;
          font-size: 18px;
          cursor: pointer;
          color: #555;
        }
        .share-popup-content {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .share-popup-subtext {
          font-size: 13px;
          color: #777;
        }
        .share-link-box {
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .share-input {
          flex: 1;
          min-width: 0;
          padding: 6px 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 13px;
        }
        .copy-btn {
          padding: 6px 10px;
          background: #3b82f6;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 13px;
        }
        .copy-btn:hover {
          background: #2563eb;
        }
        .share-options {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .share-popup-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          text-align: left;
          background: none;
          border: none;
          color: #3b82f6;
          padding: 6px 0;
          cursor: pointer;
          font-size: 13px;
          text-decoration: none;
        }
        .share-popup-btn:hover {
          text-decoration: underline;
        }
        .copied-text {
          color: green;
          font-size: 12px;
          margin-top: 4px;
        }
        .share-popup-icon {
          width: 16px;
          height: 16px;
        }
        @media screen and (max-width: 768px) {
          .share-popup {
            position: fixed;
            top: calc(var(--app-header-height, 64px) + 8px);
            left: 12px;
            right: 12px;
            width: auto;
            max-width: none;
            box-sizing: border-box;
          }
        }
      `}</style>

      {location.pathname.includes("/afterchatbot") && (
        <div className="share-popup-root">
          <button type="button" className="header-share-btn" onClick={() => setShowPopup(!showPopup)}>
            <img src={ShareIcon} alt="Share" style={{ width: "16px", height: "16px" }} />
            Share
          </button>

          {showPopup && (
            <div className="share-popup" ref={popupRef}>
              <div className="share-popup-header">
                <span className="share-popup-title">Share this chat</span>
                <button type="button" className="share-popup-close-btn" onClick={() => setShowPopup(false)}>×</button>
              </div>

              <div className="share-popup-content">
                <p className="share-popup-subtext">Anyone with the link can view this conversation.</p>
                
                <div className="share-link-box">
                  <input type="text" readOnly value={shareLink} className="share-input" />
                  <button type="button" className="copy-btn" onClick={handleCopy}>Copy</button>
                </div>
                {copied && <span className="copied-text">Link copied!</span>}

                <div className="share-options">
  <a
    href={`https://wa.me/?text=${encodeURIComponent(shareLink)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="share-popup-btn"
  >
    <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" className="share-popup-icon" />
    Share to WhatsApp
  </a>

  <a
    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareLink)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="share-popup-btn"
  >
    <img src="https://cdn-icons-png.flaticon.com/512/733/733579.png" alt="Twitter" className="share-popup-icon" />
    Share to Twitter
  </a>

    <a
    href={`https://mail.google.com/mail/?view=cm&fs=1&su=Check this chat&body=${encodeURIComponent(shareLink)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="share-popup-btn"
  >
    <img src="https://cdn-icons-png.flaticon.com/512/732/732200.png" alt="Email" className="share-popup-icon" />
    Share via Gmail
  </a>

</div>

              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
